import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "app/core/services/alert.service";
import { AuthService } from "app/core/services/auth.service";
import { PermissionService } from "app/core/services/permissions.service";
import { RoleService } from "app/core/services/role.service";
import { RouteInfo } from "app/interfaces/sidebar/route-info.interface";
import { environment } from "environments/environment";

@Component({
  moduleId: module.id,
  selector: "sidebar",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  private readonly hiddenDevicePathsForIntegratedCamera = [
    "device-videos-list",
    "dev",
  ];

  constructor(
    public translate: TranslateService,
    public permissionService: PermissionService,
    public authService: AuthService,
    public roleService: RoleService,
    public alertService: AlertService,
    public router: Router
  ) {}

  public foo = this.transform("nameProject");

  changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  transform(key: any): any {
    // return this.translate.data[key] || key;
  }

  isNotMobileMenu(): boolean {
    if (window.outerWidth > 991) {
      return false;
    }
    return true;
  }

  ngOnInit(): void {
    let typeUser = AuthService.getFromStorage(
      environment.storageTypeUserNameApi
    );
    if (typeUser == "adminAccess") {
      this.menuItems = ROUTESSUPERADMIN.filter((menuItem) => menuItem);
      this.getPermissionsBySuperAdminUser();
    } else if (typeUser == "clientuser") {
      this.menuItems = ROUTESUSERADMIN.filter((menuItem) => menuItem);
      this.getPermissionsByAdminUser();
    } else if (typeUser == "clientuserNoAdmin") {
      this.menuItems = ROUTESUSERNOADMIN.filter((menuItem) => menuItem);
      this.getPermissionsByNoAdminUser();
    }
  }

  // Get Permissions Super Admin User
  getPermissionsBySuperAdminUser(): void {
    for (let item of this.menuItems) {
      item.disabled = false;
      if (item.children) {
        for (let childremItem of item.children) {
          childremItem.disabled = false;
        }
      }
    }

    this.applyDeviceTypeVisibility();
  }

  // Get Permissions Admin User
  getPermissionsByAdminUser(): void {
    for (let item of this.menuItems) {
      item.disabled = false;
      if (item.children) {
        for (let childremItem of item.children) {
          childremItem.disabled = false;
        }
      }
    }

    this.applyDeviceTypeVisibility();
  }

  // Get Permissions No Admin User
  getPermissionsByNoAdminUser(): void {
    this.authService.getUserPermissions().subscribe({
      next: (response) => {
        this.authService.saveLocalStorage(
          environment.storageUserPermissionsNameApi,
          JSON.stringify(response.data)
        );
      },
      error: (e) => {
        this.authService.deleteAllStorage();
        this.router.navigateByUrl("/public/login");
      },
      complete: () => {
        this.getViewPermissionsByNoAdminUser();
      },
    });
  }

  // Get View Permissions No Admin User
  getViewPermissionsByNoAdminUser(): void {
    let viewPermissions;
    this.authService
      .getUserViewPermissions(
        Number(
          this.authService.getFromStorage(environment.storageIdUserNameApi)
        )
      )
      .subscribe({
        next: (response) => {
          viewPermissions = response.data;
          this.authService.saveLocalStorage(
            environment.storageUserViewPermissionsNameApi,
            JSON.stringify(response.data)
          );

          if (!Array.isArray(viewPermissions) || viewPermissions.length === 0) {
            this.alertService.error(
              this.translate.instant("validations.noViewPermissionsAssigned"),
              { autoClose: false }
            );
            setTimeout(() => this.router.navigateByUrl("/public/login"), 5000);
            return;
          }

          for (let viewpermission of viewPermissions) {
            for (let item of this.menuItems) {
              if (item.path == viewpermission.permission_path) {
                item.disabled = false;
              }

              if (item.children != undefined) {
                for (let childremItem of item.children) {
                  if (childremItem.path == viewpermission.permission_path) {
                    childremItem.disabled = false;
                    item.disabled = false;
                  }
                }
              }
            }
          }

          this.applyDeviceTypeVisibility();

          const redirectPath = this.getFirstEnabledMenuPath();

          if (!redirectPath) {
            this.alertService.error(
              this.translate.instant("validations.noValidViewPermissions"),
              { autoClose: false }
            );
            setTimeout(() => this.router.navigateByUrl("/public/login"), 5000);
            return;
          }

          this.router.navigateByUrl("/noadmin-panel/" + redirectPath);

          // const keys = Object.keys(response.data);
          // console.log("keys");
          // console.log(keys);
          /*  for (let i = 0; i < keys.length; i++) {
            for (let item of this.menuItems) {
              const key = keys[i];
              if (key == item.path) {
                item.disabled = false;
                for (let itemChildrenRoute of response.data[key]) {
                  if (item.children != undefined) {
                    for (let childremItem of item.children) {
                      if (itemChildrenRoute == childremItem.path) {
                        if (!childremItem.extraPermission) {
                          childremItem.disabled = false;
                        } else {
                          for (let j = 0; j < keys.length; j++) {
                            const ke = keys[j];
                            if (
                              this.findKeyInArray(
                                response.data[ke],
                                childremItem.extraPermission
                              )
                            ) {
                              childremItem.disabled = false;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } */
        },
        error: (e) => {
          this.authService.deleteAllStorage();
          this.router.navigateByUrl("/public/login");
        },
        complete: () => {},
      });
  }

  findKeyInArray(array, key): boolean {
    // The variable results needs var in this case (without 'var' a global variable is created)
    var results = [];
    for (var i = 0; i < array.length; i++) {
      if (array[i].indexOf(key) == 0) {
        results.push(array[i]);
        return true;
      }
    }
    return false;
  }

  private applyDeviceTypeVisibility(): void {
    if (AuthService.isExternalRecorderEnabled()) {
      return;
    }

    for (let item of this.menuItems) {
      if (item.path !== "devices" || !item.children) {
        continue;
      }

      for (let childremItem of item.children) {
        if (
          this.hiddenDevicePathsForIntegratedCamera.includes(childremItem.path)
        ) {
          childremItem.disabled = true;
        }
      }
    }
  }

  private getFirstEnabledMenuPath(): string {
    let redirectPath = "";
    let positionItem = 5000;

    for (let item of this.menuItems) {
      if (!item.disabled && item.position < positionItem) {
        redirectPath = item.path;
        positionItem = item.position;
      }

      if (item.children) {
        for (let childremItem of item.children) {
          if (!childremItem.disabled && childremItem.position < positionItem) {
            redirectPath = item.path + "/" + childremItem.path;
            positionItem = childremItem.position;
          }
        }
      }
    }

    return redirectPath;
  }
}

//Menu Items
export const ROUTESSUPERADMIN: RouteInfo[] = [
  {
    path: "dashboard-superadmin",
    title: "menuItems.dashboard",
    type: "link",
    icontype: "sidebar-icon-dashboard",
    disabled: true,
  },

  {
    path: "clients",
    title: "menuItems.clients",
    type: "link",
    icontype: "sidebar-icon-clients",
    disabled: true,
  },

  {
    path: "users-admin",
    title: "menuItems.users",
    type: "link",
    icontype: "sidebar-icon-users-admin",
    disabled: true,
  },
  {
    path: "users-noadmin",
    title: "menuItems.usersnoadmin",
    type: "link",
    icontype: "sidebar-icon-users-noadmin",
    disabled: true,
  },
  {
    path: "master-clusters",
    title: "menuItems.masterclusters",
    type: "link",
    icontype: "sidebar-icon-mastercluster",
    disabled: true,
  },
  {
    path: "profile",
    title: "menuItems.profile",
    type: "link",
    display: "none",
    icontype: "sidebar-icon-mastercluster",
    disabled: true,
  },
];
export const ROUTESUSERADMIN: RouteInfo[] = [
  {
    path: "dashboard",
    title: "menuItems.dashboard",
    type: "link",
    icontype: "sidebar-icon-dashboard",
    disabled: true,
  },
  {
    path: "administration",
    title: "menuItems.administration",
    type: "sub",
    collapse: "administration",
    icontype: "sidebar-icon-administration",
    disabled: true,
    children: [
      {
        path: "users",
        title: "menuItems.administration.users",
        ab: "U",
        disabled: true,
      },
      {
        path: "groups",
        title: "menuItems.administration.groups",
        ab: "G",
        disabled: true,
      },
      {
        path: "roles",
        title: "menuItems.administration.roles",
        ab: "R",
        disabled: true,
      },

      {
        path: "police-stations",
        title: "menuItems.administration.policeStations",
        ab: "PS",
        disabled: true,
      },
      /* 
      {
        path: "connectivity",
        title: "menuItems.administration.connectivity",
        ab: "C",
      }, */
      /*  {
        path: "policies",
        title: "menuItems.administration.policies",
        ab: "P",
      }, */
    ],
  },

  {
    path: "videos",
    title: "menuItems.videos",
    type: "sub",
    collapse: "videos",
    icontype: "sidebar-icon-videos",
    disabled: true,
    children: [
      {
        path: "list-myvideos-list",
        title: "menuItems.videos.listMyVideos",
        ab: "LMV",
        disabled: true,
      },
      {
        path: "list-allvideos-list",
        title: "menuItems.videos.listAllVideos",
        ab: "LAV",
        disabled: true,
      },
      {
        path: "list-sharedvideos-list",
        title: "menuItems.videos.listSharedVideos",
        ab: "LSV",
        disabled: true,
      },
      {
        path: "list-sharedownvideos-list",
        title: "menuItems.videos.sharedOwnVideos",
        ab: "LSOV",
        disabled: true,
      },

      /*    {
        path: "video-filters",
        title: "menuItems.videos.videoFilters",
        ab: "VF",
        disabled: true,
      }, */
      {
        path: "video-bookmarks",
        title: "menuItems.videos.videoBookmarks",
        ab: "VB",
        disabled: true,
      },
    ],
  },
  {
    path: "incidents",
    title: "menuItems.incidents",
    type: "sub",
    collapse: "incidents",
    icontype: "sidebar-icon-incident",
    disabled: true,
    children: [
      {
        path: "list-myincidents-list",
        extraPermission: "show-myincident-footage",
        title: "menuItems.incidents.listMyIncidents",
        ab: "LMI",
        disabled: true,
      },
      {
        path: "list-allincidents-list",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.listAllIncidents",
        ab: "LAI",
        disabled: true,
      },
      {
        path: "list-sharedincidents-list",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.listSharedIncidents",
        ab: "LSI",
        disabled: true,
      },
      {
        path: "list-sharedownincidents-list",
        title: "menuItems.incidents.listSharedOwnIncidents",
        ab: "LSOI",
        disabled: true,
      },
      {
        path: "incident-bookmarks",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.incidentBookmarks",
        ab: "IB",
        disabled: true,
      },
      /*    {
        path: "incident-map",
        title: "menuItems.incidents.incidentMap",
        ab: "IM",
        disabled: true,
      }, */
    ],
  },
  {
    path: "collections",
    title: "menuItems.collections",
    type: "sub",
    collapse: "collections",
    icontype: "sidebar-icon-collections",
    disabled: true,
    children: [
      {
        path: "listmycollections-list",
        title: "menuItems.collections.listMyCollections",
        ab: "LC",
        disabled: true,
      },

      {
        path: "listallcollections-list",
        title: "menuItems.collections.listAllCollections",
        ab: "LAC",
        disabled: true,
      },
    ],
  },

  {
    path: "devices",
    title: "menuItems.devices",
    type: "sub",
    collapse: "devices",
    icontype: "sidebar-icon-devices",
    disabled: true,
    children: [
      {
        path: "listmydevices-list",
        title: "menuItems.devices.listMyDevices",
        ab: "LMSD",
        disabled: true,
      },
      {
        path: "listalldevices-list",
        title: "menuItems.devices.listAllDevices",
        ab: "LAD",
        disabled: true,
      },

      {
        path: "list-devicesuser-list",
        title: "menuItems.devices.manageDevices",
        extraPermission: "list-users",
        ab: "LMSD",
        disabled: true,
      },
      {
        path: "device-videos-list",
        title: "menuItems.devices.listDeviceVideos",
        ab: "DVL",
        disabled: true,
      },
      {
        path: "dev",
        title: "menuItems.devices.devConsole",
        // extraPermission: "dev",
        ab: "DEV",
        disabled: true,
      },
    ],
  },

  {
    path: "tactical-map",
    title: "menuItems.tacticalMap",
    type: "link",
    icontype: "sidebar-icon-map",
    collapse: "tactical-map-devices",
    disabled: true,
  },
  {
    path: "notifications",
    title: "menuItems.notifications",
    type: "sub",
    collapse: "notifications",
    icontype: "sidebar-icon-notification",
    disabled: true,
    children: [
      {
        path: "list-notifications-list",
        title: "menuItems.notifications.listNotifications",
        extraPermission: "",
        ab: "LA",
        disabled: true,
      },
    ],
  },
  {
    path: "reports",
    title: "menuItems.reports",
    type: "sub",
    collapse: "reports",
    icontype: "sidebar-icon-reports",
    disabled: true,
    children: [
      {
        path: "list-auditlogs",
        title: "menuItems.reports.listAuditLogs",
        ab: "LA",
        disabled: true,
      },
      {
        path: "list-auditlogs-byuser",
        extraPermission: "list-users",
        title: "menuItems.reports.listAuditLogsByUser",
        ab: "LAU",
        disabled: true,
      },
    ],
  },
  {
    path: "system",
    title: "menuItems.system",
    type: "sub",
    icontype: "sidebar-icon-system",
    collapse: "system",
    disabled: true,
    children: [
      {
        path: "list-policies",
        title: "menuItems.system.listPolicies",
        ab: "LP",
        disabled: true,
      },
      {
        path: "list-videorecord-logs",
        title: "menuItems.system.listVideoRecordLogs",
        ab: "LP",
        disabled: true,
      },
    ],
  },
];

export const ROUTESUSERNOADMIN: RouteInfo[] = [
  {
    path: "dashboard",
    title: "menuItems.dashboard",
    type: "link",
    icontype: "sidebar-icon-dashboard",
    disabled: true,
    position: 0,
  },
  {
    path: "administration",
    title: "menuItems.administration",
    type: "sub",
    collapse: "administration",
    icontype: "sidebar-icon-administration",
    disabled: true,
    position: 1,
    children: [
      {
        path: "users",
        title: "menuItems.administration.users",
        ab: "U",
        disabled: true,
        position: 2,
      },
      {
        path: "groups",
        title: "menuItems.administration.groups",
        ab: "G",
        disabled: true,
        position: 3,
      },
      {
        path: "roles",
        title: "menuItems.administration.roles",
        ab: "R",
        disabled: true,
        position: 4,
      },
      {
        path: "police-stations",
        extraPermission: "get-policestation-devices",
        title: "menuItems.administration.policeStations",
        ab: "PS",
        disabled: true,
        position: 5,
      },
      /* 
      {
        path: "connectivity",
        title: "menuItems.administration.connectivity",
        ab: "C",
      }, */
      /*  {
        path: "policies",
        title: "menuItems.administration.policies",
        ab: "P",
      }, */
    ],
  },

  {
    path: "videos",
    title: "menuItems.videos",
    type: "sub",
    collapse: "videos",
    icontype: "sidebar-icon-videos",
    disabled: true,
    position: 6,
    children: [
      {
        path: "list-myvideos-list",
        title: "menuItems.videos.listMyVideos",
        ab: "LMV",
        disabled: true,
        position: 7,
      },
      {
        path: "list-allvideos-list",
        title: "menuItems.videos.listAllVideos",
        ab: "LAV",
        disabled: true,
        position: 8,
      },
      {
        path: "list-sharedvideos-list",
        title: "menuItems.videos.listSharedVideos",
        ab: "LSV",
        disabled: true,
        position: 9,
      },
      {
        path: "list-sharedownvideos-list",
        title: "menuItems.videos.sharedOwnVideos",
        ab: "LSOV",
        disabled: true,
        position: 10,
      },
      /*  {
        path: "video-filters",
        title: "menuItems.videos.videoFilters",
        ab: "VF",
        disabled: true,
      }, */
      {
        path: "video-bookmarks",
        title: "menuItems.videos.videoBookmarks",
        ab: "VB",
        disabled: true,
        position: 11,
      },
    ],
  },
  {
    path: "incidents",
    title: "menuItems.incidents",
    type: "sub",
    collapse: "incidents",
    icontype: "sidebar-icon-incident",
    disabled: true,
    position: 12,
    children: [
      {
        path: "list-myincidents-list",
        extraPermission: "show-myincident-footage",
        title: "menuItems.incidents.listMyIncidents",
        ab: "LMI",
        disabled: true,
        position: 13,
      },
      {
        path: "list-allincidents-list",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.listAllIncidents",
        ab: "LAI",
        disabled: true,
        position: 14,
      },
      {
        path: "list-sharedincidents-list",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.listSharedIncidents",
        ab: "LSI",
        disabled: true,
        position: 15,
      },
      {
        path: "list-sharedownincidents-list",
        title: "menuItems.incidents.listSharedOwnIncidents",
        ab: "LSOI",
        disabled: true,
        position: 16,
      },
      {
        path: "incident-bookmarks",
        extraPermission: "show-footage-by-incident",
        title: "menuItems.incidents.incidentBookmarks",
        ab: "IB",
        disabled: true,
        position: 17,
      },
      /*    {
        path: "incident-map",
        title: "menuItems.incidents.incidentMap",
        ab: "IM",
        disabled: true,
      }, */
    ],
  },
  {
    path: "collections",
    title: "menuItems.collections",
    type: "sub",
    collapse: "collections",
    icontype: "sidebar-icon-collections",
    disabled: true,
    position: 18,
    children: [
      {
        path: "listmycollections-list",
        title: "menuItems.collections.listMyCollections",
        ab: "LC",
        disabled: true,
        position: 19,
      },

      {
        path: "listallcollections-list",
        title: "menuItems.collections.listAllCollections",
        ab: "LAC",
        disabled: true,
        position: 20,
      },
    ],
  },

  {
    path: "devices",
    title: "menuItems.devices",
    type: "sub",
    collapse: "devices",
    icontype: "sidebar-icon-devices",
    disabled: true,
    position: 21,
    children: [
      {
        path: "listmydevices-list",
        title: "menuItems.devices.listMyDevices",
        ab: "LMSD",
        disabled: true,
        position: 22,
      },
      {
        path: "listalldevices-list",
        title: "menuItems.devices.listAllDevices",
        ab: "LAD",
        disabled: true,
        position: 23,
      },

      {
        path: "list-devicesuser-list",
        title: "menuItems.devices.manageDevices",
        extraPermission: "list-users",
        ab: "LMSD",
        disabled: true,
        position: 24,
      },
      {
        path: "device-videos-list",
        title: "menuItems.devices.listDeviceVideos",
        ab: "DVL",
        disabled: true,
        position: 25,
      },
      {
        path: "dev",
        title: "menuItems.devices.devConsole",
        extraPermission: "manage-videorecord",
        ab: "DEV",
        disabled: true,
        position: 26,
      },
      {
        path: "list-auditdevices",
        title: "menuItems.devices.listAuditDevices",
        ab: "LAD",
        disabled: true,
        position: 27,
      },
    ],
  },

  {
    path: "tactical-map",
    title: "menuItems.tacticalMap",
    type: "link",
    icontype: "sidebar-icon-map",
    collapse: "tactical-map-devices",
    disabled: true,
    position: 28,
  },
  {
    path: "notifications",
    title: "menuItems.notifications",
    type: "sub",
    collapse: "notifications",
    icontype: "sidebar-icon-notification",
    disabled: true,
    position: 29,
    children: [
      {
        path: "list-notifications-list",
        title: "menuItems.notifications.listNotifications",
        extraPermission: "",
        ab: "LA",
        disabled: true,
        position: 30,
      },
    ],
  },
  {
    path: "reports",
    title: "menuItems.reports",
    type: "sub",
    collapse: "reports",
    icontype: "sidebar-icon-reports",
    disabled: true,
    position: 31,
    children: [
      {
        path: "list-auditlogs",
        title: "menuItems.reports.listAuditLogs",
        ab: "LAL",
        disabled: true,
        position: 32,
      },
      {
        path: "list-auditlogs-byuser",
        extraPermission: "list-users",
        title: "menuItems.reports.listAuditLogsByUser",
        ab: "LALU",
        disabled: true,
        position: 33,
      },
    ],
  },
  {
    path: "system",
    title: "menuItems.system",
    type: "sub",
    icontype: "sidebar-icon-system",
    collapse: "system",
    disabled: true,
    position: 34,
    children: [
      {
        path: "list-policies",
        title: "menuItems.system.listPolicies",
        ab: "LP",
        disabled: true,
        position: 35,
      },
      {
        path: "list-videorecord-logs",
        title: "menuItems.system.listVideoRecordLogs",
        ab: "LP",
        disabled: true,
        position: 36,
      },
    ],
  },
];
